<div class="custom-table-wrapper">
  <div class="no-data" *ngIf="!data">
    <app-loader [isPage]="true"></app-loader>
  </div>
  <div *ngIf="data && !data.length">{{noRecordTxt}}</div>
  <div class="count" *ngIf="data && data.length && showCount">{{data.length}} results</div>
  <table class="custom-table" *ngIf="data && data.length">
    <thead>
      <tr>
        <th *ngFor="let header of headers" [ngStyle]="{ width: header.width ? header.width : 'none'}" (click)="sortData(header)">
          <p>{{ header.name }}</p>
          <span
            [ngClass]="header.sort == 'none' ? 'asc' : ''"
            [hidden]="
              header.name == '' ||
              header.name == null ||
              header.sort == 'asc' ||
              header.sort == 'none'
            "
          >
            <i class="fa fa-caret-up" aria-hidden="true"></i>
          </span>
          <span
            [hidden]="
              header.name == '' ||
              header.name == null ||
              header.sort == 'desc' ||
              header.sort == 'none'
            "
          >
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </span>
          <span
            [hidden]="
              header.name == '' ||
              header.name == null ||
              header.sort == 'desc' || header.sort == 'asc'
            "
          >
            <i class="fa fa-sort" aria-hidden="true"></i>
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="table-row" *ngFor="let item of data">
        <td
          *ngFor="let header of headers; let last = last"
          [ngSwitch]="header.type"
          [ngStyle]="{ width: header.width ? header.width : 'none'}"
        >
          <span class="link" *ngSwitchCase="'link'">
            <span (click)="link(item)">
              {{ item[header.key] }}
            </span>
          </span>
          <span *ngSwitchCase="'date'" >
            <span *ngIf="item[header.key] !== '' && item[header.key] !== null">
              {{ item[header.key] | datePipe }}
            </span>
          </span>
          <span *ngSwitchCase="'searchName'">
            <div innerHtml="{{ item[header.key] | highlightText : searchText }}"></div>
          </span>
          <span class="table-btns" *ngSwitchCase="'edit-delete-button'">
            <div class="spacer"></div>
            <app-button
              [name]="'edit'"
              [type]="'small-outlined'"
              (btnClick)="edit(item)"
            ></app-button>
            <app-button
              [type]="'table-delete'"
              (btnClick)="delete(item)"
            ></app-button>
          </span>

          <span class="table-btns" *ngSwitchCase="'delete-download-button'">
            <div class="spacer"></div>
            <span class="download">
                <app-button [type]="'small-outlined-download'" (btnClick)="download(item)"></app-button>
              </span>
            <app-button
              [type]="'table-delete'"
              (btnClick)="delete(item)"
            ></app-button>
          </span>

          <span class="table-btns" *ngSwitchCase="'download-button'">
            <div class="spacer"></div>
            <span class="download">
                <app-button [type]="'small-outlined-download'" (btnClick)="download(item)"></app-button>
              </span>
          </span>

          <span class="table-btns" *ngSwitchCase="'update-delete-button'">
            <div class="spacer"></div>
            <app-button
              [type]="'update-data'"
              (btnClick)="edit(item)"
            ></app-button>
            <app-button
              [type]="'table-delete'"
              (btnClick)="delete(item)"
            ></app-button>
          </span>

          <span class="table-btns" *ngSwitchCase="'view-button'">
            <div class="spacer"></div>
            <app-button
              [name]="'view'"
              [type]="'small-outlined'"
              (btnClick)="onSelect(item)"
            >
            </app-button>
          </span>

          <span class="table-btns" *ngSwitchCase="'view-consent-btn'">
            <div class="spacer"></div>
            <app-button *ngIf="item.isConsentPublished === '1' && 
            (!item.consentFilePath)"
              [name]="'view Consent'"
              [type]="'small-outlined'"
              [textTransformNone]="true"
              (btnClick)="onSelect(item)"
            >
            </app-button>
            <app-button *ngIf="item.isConsentPublished === '1' && 
            (item.consentFilePath)" [type]="'small-outlined-download'" (btnClick)="download(item)"></app-button>
          </span>


          <span class="table-btns" *ngSwitchCase="'lock-detail-button'">
            <div class="spacer"></div>
            <span class="download">
              <app-button
              [name]="''"
              [type]="(item['isLocked'] === '0') ? 'unlock': 'lock'"
              (btnClick)="lock(item)"
            >
            </app-button>
             </span>
                        <app-button
                        [name]="'Details'"
                        [type]="'outlined'"
                        (btnClick)="onSelect(item)"
                      >
                      </app-button>
          </span>

          <span class="table-btns" *ngSwitchCase="'detail-button'">
            <app-button
                        [name]="'Details'"
                        [type]="'outlined'"
                        (btnClick)="onSelect(item)"
                      >
                      </app-button>
          </span>

          <span class="table-btns" *ngSwitchCase="'edit-button'">
            <div class="spacer"></div>
            <app-button
              [name]="'edit'"
              [type]="'small-outlined'"
              (btnClick)="onSelect(item)"
            >
            </app-button>
          </span>

          <span *ngSwitchDefault>
            {{ item[header.key] }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
